var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockDesk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M224 96C232.8 96 240 103.2 240 112V217.4L283.3 260.7C289.6 266.9 289.6 277.1 283.3 283.3C277.1 289.6 266.9 289.6 260.7 283.3L212.7 235.3C209.7 232.3 207.1 228.2 207.1 224V112C207.1 103.2 215.2 96 223.1 96H224zM224 0C347.7 0 448 100.3 448 224V448C448 483.3 419.3 512 384 512H64C28.65 512 0 483.3 0 448V224C0 100.3 100.3 0 224 0zM224 32C117.1 32 32 117.1 32 224C32 330 117.1 416 224 416C330 416 416 330 416 224C416 117.1 330 32 224 32zM416 339.4C376.8 404.5 305.5 448 224 448C142.5 448 71.2 404.5 32 339.4V448C32 465.7 46.33 480 64 480H384C401.7 480 416 465.7 416 448V339.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockDesk);
export default __webpack_public_path__ + "static/media/clock-desk.f70d3c570f8711cd5dc67b89bee78b7f.svg";
export { ForwardRef as ReactComponent };